export { default } from "./boolWidget";
